import Promise from 'bluebird'

export function parseDocumentsToObject(docs)  {
  var response = {}
  docs.forEach(doc => {
    response[doc.id] = parseDocument(doc)
  });
  return response
}

export function parseDocumentsToArray(docs, sortBy, desc)  {
  var response = []
  docs.forEach(doc => {
    response.push(parseDocument(doc))
  });
  if (sortBy) {
    response = response.sort((a, b) => {
      var order = 0
      if (a[sortBy] > b[sortBy]) {
        order = 1
      } else if (a[sortBy] < b[sortBy]) {
        order = -1
      }
      if (desc) {
        order *= -1
      }
      return order;
    })
  }
  return response
}

export const parseDocument = (firebaseDocument) => {
  return { id: firebaseDocument.id, ...firebaseDocument.data() }
}

export const populateFields = async (firebaseData, fields = []) => {
  await Promise.map(fields, async (field) => {
    const poRef = await firebaseData[field].get()
    firebaseData[field] = poRef.data()
  })
  return firebaseData
}

export const populateCollections = async (doc, collections = []) => {
  var firebaseData = parseDocument(doc)
  await Promise.map(collections, async (collection) => {
    const result = await doc.collection(collection).get()
    firebaseData[collection] = result.docs.map(parseDocument)
  })
  return firebaseData
}


// WEBPACK FOOTER //
// ./src/utils/populations.js